import type { RotasDoModulo } from '@/app/rotas';

import { AdvisorBrokersPage } from './AdvisorBrokersPage';
import { AdvisorSessionPage } from './AdvisorSessionPage';
import { AdvisorsPage } from './AdvisorsPage';
import { BrokerDetailPage } from './BrokerDetailPage';
import { BrokerOnboardingPage } from './BrokerOnboardingPage';
import { BrokerSelfPage } from './BrokerSelfPage';
import { BrokersPage } from './BrokersPage';

/**
 * A lista de corretores, da seguradora, o cadastro completo de cada corretor
 * (P-COR-1), o assistente de cadastro de corretor (P-COR-2), o cadastro da propria
 * corretora e as assessorias com as corretoras de cada uma (P-COR-3).
 */
export const rotas: RotasDoModulo = {
  menu: {
    '/corretores': BrokersPage,
    '/corretora': BrokerSelfPage,
    '/assessorias': AdvisorsPage,
  },
  moldura: [
    {
      path: '/corretores/:brokerId',
      element: <BrokerDetailPage />,
    },
    // O caminho fixo vence o :brokerId: o React Router escolhe a rota mais especifica.
    {
      path: '/corretores/novo',
      element: <BrokerOnboardingPage />,
    },
    {
      path: '/assessorias/:advisorId/corretores',
      element: <AdvisorBrokersPage />,
    },
    // A escolha da corretora do assessor (P-ACE-2), fora do menu: a tela inicial leva
    // a ela quem entrou pela assessoria e ainda nao escolheu.
    {
      path: '/assessoria/corretoras',
      element: <AdvisorSessionPage />,
    },
  ],
};
